import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=0fb1bab4&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "../../styles/product-card.css?vue&type=style&index=0&id=0fb1bab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1bab4",
  null
  
)

export default component.exports